/**
 * List of LOVS used in application
 */

export const LOV_KEYS = {
  SCOOL_FORMS_SCREEN: 'SCHOOL_FORMS_SCREEN',
  SCHOOL_FORMS_ACADEMIC_YEAR_ASR: 'SCHOOL_FORMS_ACADEMIC_YEAR_ASR',
  SCHOOL_FORMS_ACADEMIC_YEAR_LHD: 'SCHOOL_FORMS_ACADEMIC_YEAR_LHD',
  USER_REVOKE_REASON: 'USER_REVOKE_REASON',
  REVOKE_REASON : 'REVOKE_REASON',
  USER_STATUS: 'USER_STATUS',
  SYSTEM: 'SYSTEM',
  MS_SYSTEM: 'GET_SYSTEM',
  GROUP: 'GROUP',
  MS_GROUP: 'GET_FACILITY_GROUP',
  MS_SYSTEM_GROUP: 'GET_SYSTEM_GROUP_MAP',
  INTERFACE_ENTITY: 'INTERFACE_ENTITY',
  VENDOR: 'VENDOR',
  MS_VENDOR: 'GET_VENDOR_LIST',
  FACILITY_HRCHY: 'FACILITY_HRCHY',
  FACILITY_TYPE: 'FACILITY_TYPE',
  FACILITY_SUB_TYPE: 'FACILITY_SUB_TYPE',
  AF_CLASSIFICATION: 'AF_CLASSIFICATION',
  AF_SPECIALIZATION: 'AF_SPECIALIZATION',
  VFC_PED_TYPE: 'VFC_PED_TYPE',
  VFC_ADULT_TYPE: 'VFC_ADULT_TYPE',
  ADDRESS_TYPE: 'ADDR_TYPE',
  STATE: 'STATE',
  PHONE_TYPE: 'PHONE_TYPE',
  EMAIL_TYPE: 'EMAIL_TYPE',
  BASIC_CONTACT_TYPE: 'BASIC_CONTACT_TYPE',
  CONTACT_TYPE: 'CONTACT_TYPE',
  ENTITY_INTFC_TYPE: 'ENTITY_INTFC_TYPE',
  INTFC_ENTITY_TYPE:'INTFC_ENTITY_TYPE',
  FACILITY_INTFC_TYPE: 'FACILITY_INTFC_TYPE',
  INTFC_ACCESS_TYPE: 'INTFC_ACCESS_TYPE',
  INTFC_ENROLL_ACCESS_TYPE: 'INTFC_ENROLL_ACCESS_TYPE',
  PROFILE_TYPE: 'PROFILE_TYPE',
  INTFC_ENGINE: 'INTFC_ENGINE',
  INTFC_FILE_TYPE: 'INTFC_FILE_TYPE',
  INTFC_FILE_VERSION: 'INTFC_FILE_VERSION',
  ENTITY_TYPE: 'ENTITY_TYPE',
  STATUS: 'STATUS',
  NOTE_TYPE: 'NOTE_TYPE',
  VFC_ENROLL_TYPE: 'VFC_ENROLL_TYPE',
  VFC_NEW_ENROLL_PERIOD: 'VFC_NEW_ENROLL_PERIOD',
  VFC_RE_ENROLL_PERIOD: 'VFC_RE_ENROLL_PERIOD',
  VFC_MENU_ENROLL: 'VFC_MENU_ENROLL',
  VFC_MENU_RE_ENROLL: 'VFC_MENU_RE_ENROLL',
  VFC_MENU_ENROLL_ADMIN: 'VFC_MENU_ENROLL_ADMIN',
  VFC_MENU_ADMIN_EDIT: 'VFC_MENU_ADMIN_EDIT',
  VFC_TYPE: 'VFC_TYPE',
  VFC_FACILITY_TYPE_PED: 'VFC_FACILITY_TYPE_PED',
  VFC_FACILITY_TYPE_ADULT: 'VFC_FACILITY_TYPE_ADULT',
  VFC_PED_VACCINE_OFFERED: 'VFC_PED_VACCINE_OFFERED',
  VFC_ADULT_VACCINE_OFFERED: 'VFC_ADULT_VACCINE_OFFERED',
  VFC_THERMOMETER_CATEGORY: 'VFC_THERMOMETER_CATEGORY',
  VFC_THERMOMETER_TYPE: 'VFC_THERMOMETER_TYPE',
  VFC_STORAGE_CAPACITY_TYPE: 'VFC_STORAGE_CAPACITY_TYPE',
  VFC_ENROLL_TYPE_PED_VFC: 'VFC_ENROLL_TYPE_PED_VFC',
  VFC_ENROLL_TYPE_PED_NON_VFC: 'VFC_ENROLL_TYPE_PED_NON_VFC',
  VFC_ENROLL_TYPE_ADULT_VFC: 'VFC_ENROLL_TYPE_ADULT_VFC',
  VFC_ENROLL_TYPE_ADULT_NON_VFC: 'VFC_ENROLL_TYPE_ADULT_NON_VFC',
  VFC_PHYSICIAN_TYPE: 'VFC_PHYSICIAN_TYPE',
  VFC_ENROLL_FORM_STATUS: 'VFC_ENROLL_FORM_STATUS',
  VFC_STATUS: 'VFC_STATUS',
  VFC_PROV_CATEGORY: 'VFC_PROV_CATEGORY',
  WEEK_DAY: 'WEEK_DAY',
  VFC_FACILITY_VACCINE_HOLD: 'VFC_PROV_VACCINE_HOLD',
  INV_VACCINE_SOURCE: 'INV_VACCINE_SOURCE',
  ORDERING_INTENTION: 'ORDERING_INTENTION',
  VFC_VACCINES_PEDIATRIC: 'VFC_VACCINES_PEDIATRIC',
  VFC_VACCINES_ADULT: 'VFC_VACCINES_ADULT',
  COUNTRY: 'COUNTRY',
  GENDER: 'GENDER',
  RACE: 'RACE',
  ETHNICITY: 'ETHNICITY',
  LANGUAGE: 'LANGUAGE',
  TRIBE: 'TRIBE',
  PATIENT_SEARCH_PREF: 'PATIENT_SEARCH_PREF',
  INSURANCE_PROVIDER: 'INSURANCE_PROVIDER',
  INSURANCE_POLICY: 'INSURANCE_POLICY',
  EBC_HOSPITAL: 'EBC_HOSPITAL',
  RELATIONSHIP: 'RELATIONSHIP',
  CONSENT_RELATIONSHIP: 'CONSENT_RELATIONSHIP',
  PATIENT_STATUS: 'PATIENT_STATUS',
  PATIENT_STATUS_REASON: 'PATIENT_STATUS_REASON',
  VACCINE_REFUSAL_REASON: 'VACCINE_REFUSAL_REASON',
  VACCINE_PROGRAM_CODE: 'VACCINE_PROGRAM_CODE',
  VACCINE_ADMIN_SITE: 'VACCINE_ADMIN_SITE',
  VACCINE_ADMIN_ROUTE: 'VACCINE_ADMIN_ROUTE',
  VACCINE_ID: 'VACCINE_ID',
  REASON_FOR_VISIT: 'REASON_FOR_VISIT',
  MANUFACTURER: 'MANUFACTURER',
  ICE_VACCINE_GROUP: 'ICE_VACCINE_GROUP',
  ADVERSE_EVENT_QA: 'ADVERSE_EVENT_QA',
  REMINDER_ACTIVITY: 'REMINDER_ACTIVITY',
  REMINDER_DISPOSITION: 'REMINDER_DISPOSITION',
  IMM_SERIES: 'IMM_SERIES',
  REMINDER_PROCESS_TYPE: 'REMINDER_PROCESS_TYPE',
  AE_RECOVERY_STATUS: 'AE_RECOVERY_STATUS',
  NJIIS_NON_CORE_VACC_SERIES: 'NJIIS_NON_CORE_VACC_SERIES',
  NJIIS_CORE_VACC_SERIES: 'NJIIS_CORE_VACC_SERIES',
  INV_DEVICE: 'INV_DEVICE',
  IMM_LEAD_TEST_STATUS: 'IMM_LEAD_TEST_STATUS',
  IMM_TEST_SAMPLE_TYPE: 'IMM_TEST_SAMPLE_TYPE',
  INV_TRANSACTION_TYPE: 'INV_TRANSACTION_TYPE',
  IMM_TEST_RESULT: 'IMM_TEST_RESULT',
  RISK_FACTOR_CODE: 'RISK_FACTOR_CODE',
  VACCINE_BRAND: 'VACCINE_BRAND',
  VFC_VACCINE_STATUS: 'VFC_VACCINE_STATUS',
  VFC_ORDER_ITEM_STATUS: 'VFC_ORDER_ITEM_STATUS',
  VFC_ORDER_ITEM_DETAIL_STATUS: 'VFC_ORDER_ITEM_DETAIL_STATUS',
  VFC_FACILITY_ORDER_STATUS: 'VFC_FACILITY_ORDER_STATUS',
  //VFC_FACILITY_VACCINE_HOLD: "VFC_FACILITY_VACCINE_HOLD",
  VFC_MODE_OF_ORDER: 'VFC_MODE_OF_ORDER',
  VFC_FACILITY_DEFAULT_DEPOT: 'VFC_FACILITY_DEFAULT_DEPOT',
  VFC_FUNDING_TYPE: 'VFC_FUNDING_TYPE',
  //FACILITY_TYPE: "FACILITY_TYPE",
  STORAGE_UNIT_TYPE: 'STORAGE_UNIT_TYPE',
  STORAGE_UNIT_STATUS: 'STORAGE_UNIT_STATUS',
  STORAGE_UNIT_STYLE: 'STORAGE_UNIT_STYLE',
  TEMPERATURE_LOG_OFFICE_STATUS: 'TEMPERATURE_LOG_OFFICE_STATUS',
  BULLETIN_BOARD_MESSAGE_STATUS: 'BULLETIN_BOARD_MESSAGE_STATUS',
  TRAINING_LOCATION: 'TRAINING_LOCATION',
  TRAINING_TYPE: 'TRAINING_TYPE',
  INTFC_ENROLL_REASON: 'INTFC_ENROLL_REASON',
  INTFC_ENROLL_STATUS: 'INTFC_ENROLL_STATUS',
  INTFC_ENROLL_PTS_UNDER_7: 'INTFC_ENROLL_PTS_UNDER_7',
  INTFC_ENROLL_DOSES_ADMIN: 'INTFC_ENROLL_DOSES_ADMIN',
  NJIIS_INTFC_ESTD: 'NJIIS_INTFC_ESTD',
  USER_ACCESS_LEVEL: 'USER_ACCESS_LEVEL',
  FACILITY_VACC_INV: 'FACILITY_VACC_INV',
  USER_SECURITY_QUESTION: 'USER_SECURITY_QUESTION',
  TRAINING_USER: 'TRAINING_USER',
  VFC_PHYSICIAN_TITLE: 'VFC_PHYSICIAN_TITLE',
  WEBINAR: 'WEBINAR',
  RR_PROCESS_TYPE: 'RR_PROCESS_TYPE',
  RR_REMINDER_RANGE: 'RR_REMINDER_RANGE',
  RR_RECALL_RANGE: 'RR_RECALL_RANGE',
  RR_PATIENT_GROUP: 'RR_PATIENT_GROUP',
  RR_EXCLUSION_RANGE: 'RR_EXCLUSION_RANGE',
  RR_JOB_STATUS: 'RR_JOB_STATUS',
  ENTITY_SUB_TYPE: 'ENTITY_SUB_TYPE',
  INTFC_ENTITY_SUB_TYPE:'INTFC_ENTITY_SUB_TYPE',
  INTFC_ENROLL_ENTITY_SUB_TYPE: 'INTFC_ENROLL_ENTITY_SUB_TYPE',
  HL7_AUDIT_TYPE: 'HL7_AUDIT_TYPE',
  HL7_MAP: 'HL7_MAP',
  SEND_EMAIL_TYPE: 'SEND_EMAIL_TYPE',
  SEND_EMAIL_BY: 'SEND_EMAIL_BY',
  DISEASE_CONCEPT: 'DISEASE_CONCEPT',
  CONTRAIND_CONCEPT: 'CONTRAIND_CONCEPT',
  PROV_ENROLLMENT_STATUS: 'PROV_ENROLLMENT_STATUS',
  PROV_ENROLL_USER_PROFILE: 'PROV_ENROLL_USER_PROFILE',
  COVID_VFC_TYPE: 'COVID_VFC_TYPE',
  USER_AGREEMENT_PROFILE: 'USER_AGREEMENT_PROFILE',
  USER_CONF_AGREEMENT_ACCESS: 'USER_CONF_AGREEMENT_ACCESS',
  DATA_SUBMISSION_OPTIONS: 'DATA_SUBMISSION_OPTIONS',
  COVID_FACILITY_TYPE: 'COVID_FACILITY_TYPE',
  COVID_FACILITY_SUB_TYPE: 'COVID_FACILITY_SUB_TYPE',
  COVID_NEW_ENROLL_PERIOD: 'COVID_NEW_ENROLL_PERIOD',
  COVID_VACC_STORAGE_UNIT_TYPE: 'COVID_VACC_STORAGE_UNIT_TYPE',
  VFC_VACC_STORAGE_UNIT_TYPE:'VFC_VACC_STORAGE_UNIT_TYPE',
  STATE_FUND_VACC_STORAGE_UNIT_TYPE: 'STATE_FUND_VACC_STORAGE_UNIT_TYPE',
  COVID_PHYS_TITLE: 'COVID_PHYS_TITLE',
  COVID_POPULATION_SERVED: 'COVID_POPULATION_SERVED',
  COVID_LOCATION_ADMINISTERED: 'COVID_LOCATION_ADMINISTERED',
  ADVERSE_EVENT: 'ADVERSE_EVENT',
  COVID_ENROLL_FORM_STATUS: 'COVID_ENROLL_FORM_STATUS',
  HL7_EXCEL_POSITION_MAP: 'HL7_EXCEL_POSITION_MAP',
  COVID_MANUFACTURER: 'COVID_MFG',
  HL7_REQUEST_TYPE: 'HL7_REQ_TYPE',
  STATE_FUND_VFC_TYPE: 'STATE_FUND_VFC_TYPE',
  VFC_PROV_VACCINE_HOLD: 'VFC_PROV_VACCINE_HOLD',
  GRANTEE_STATE_FUND: 'GRANTEE_STATE_FUND',
  STATE_FUND_PHYS_TITLE: 'STATE_FUND_PHYS_TITLE',
  VFC_PHYS_TITLE: 'VFC_PHYS_TITLE'
};

/**
 * List of Heirarchy keys used in application
 */
export const HRCHY_KEYS = {
  COUNTY_MUNI: 'COUNTY_MUNI_HIERARCHY',
  SYSTEM_GROUP: 'SYSTEM_GROUP_HIERARCHY',
  FACILITY_SYSTEM_GROUP: 'GET_SYSTEM_GROUP_MAP',
  VFC_TYPE_HIERARCHY: 'VFC_TYPE_HIERARCHY',
  INSURANCE_HIERARCHY: 'INSURANCE_HIERARCHY',
  SERIES_VACCINE_HEIRARCHY: 'SERIES_VAC_HIERARCHY',
  ACTIVITY_DISPOSITION_HIERARCHY: 'PATIENT_ACTIVITY_DISPOSITION_HIERARCHY',
  DISEASE_TEST_HIERARCHY: 'DISEASE_TEST_HIERARCHY',
  INV_TRAN_REASON_HEIRARCHY: 'TRANSACTION_REASON_HIERARCHY',
  VFC_TYPE_VACCINE_HIERARCHY: 'VFC_TYPE_VACCINE_HIERARCHY',
  FACILITY_TYPE_VACCINE_BRAND_HIERARCHY: 'FACILITY_TYPE_VACCINE_BRAND_HIERARCHY',
  SERIES_VACCINE_CVX_HIERARCHY: 'SERIES_VAC_CVX_HIERARCHY',
  COVID_FACILITY_TYPE_FACILITY_SUB_TYPE_HIERARCHY: 'COVID_FACILITY_TYPE_FACILITY_SUB_TYPE_HIERARCHY',
  STATE_FUND_VFC_TYPE_VACCINE_HIERARCHY: 'STATE_FUND_VFC_TYPE_VACCINE_HIERARCHY',
  STATE_FUND_TYPE_HIERARCHY: 'STATE_FUND_TYPE_HIERARCHY'
};

export const GET_FACILITY_TYPE = 'GET_FACILITY_TYPE'
/**
 * EHDI lovs screen and lovs pair
 */
export const EHDI_LOVS_LKPUP_TAB_KEY_PAIR = {
  NBH_RISK_FACTOR: [{ lkpTab: 'NBH_RISK_FACTOR', key: ['RISK_FACTOR_CODE'] }],
  NBH_EBC_DATA: [
    {
      lkpTab: 'NBH_EBC_DATA',
      key: ['SCREEN_FINDINGS_LEFT', 'SCREEN_FINDINGS_RIGHT', 'SCREEN_METHOD_LEFT', 'SCREEN_METHOD_RIGHT', 'PRIMARY_LANG'],
    },
  ],
  NBH_FOLLOW_UP: [
    {
      lkpTab: 'NBH_FOLLOW_UP',
      key: [
        'DAE_DEGREE_OF_LOSS_LEFT',
        'DAE_DEGREE_OF_LOSS_RIGHT',
        'DAE_OTHER_RESULT',
        'DAE_REASSES_SCH',
        'DAE_RESULT_LEFT',
        'DAE_RESULT_RIGHT',
        'DAER_DIAG_ABR',
        'DAER_RELEASE_AUTH',
        'OPS_FINDINGS_LEFT',
        'OPS_FINDINGS_RIGHT',
        'OPS_METHOD_LEFT',
        'OPS_METHOD_RIGHT',
        'OPS_RECOMN',
        'RFU_HOSP_READMISSION',
        'RFU_PREV_SCREEN_METHOD',
        'RFU_PREV_SCREEN_RESULT_LEFT',
        'RFU_PREV_SCREEN_RESULT_RIGHT',
        'DAER_ADDITIONAL_TEST_FACILITY',
      ],
    },
  ],
  NBH_LOST_TO_FU: [
    {
      lkpTab: 'NBH_LOST_TO_FU',
      key: ['RLFU_HOSP_READMISSION', 'RLFU_PREV_SCREEN_METHOD', 'RLFU_PREV_SCREEN_RESULT_LEFT', 'RLFU_PREV_SCREEN_RESULT_RIGHT'],
    },
  ],
  NBH_FOLLOWUP_CONTACT: [
    {
      lkpTab: 'NBH_FOLLOW_UP',
      key: ['FUTURE_FOLLOWUP'],
    },
  ],
};
